export const humanFileSize = (size: number): string => {
  const i = size ? Math.floor(Math.log(size) / Math.log(1024)) : 0;

  return `${(size / 1024 ** i).toFixed(2)} ${['B', 'KB', 'MB', 'GB', 'TB'][i]}`;
};
